import React from 'react';
import { Button, Items, Message, Separator } from 'common/components';
import { Glossary, BoardGL } from 'common/utils/glossary';

interface SelectLanguageBoardProps {
  /** SelectLanguageBoardの表示有無 */
  isDisplay: boolean;
  /** グロッサリ */
  glossary: Glossary;
  /** クローズボタンをクリックした際の処理 */
  onClickClose: () => void;
  /** 言語のリスト */
  items: {
    id: string;
    text: string;
    select: true | false;
    onClick: (key: string) => void;
  }[];
  /** 選択言語 */
  selectedLanguage: string;
}

/**
 * 言語選択画面のPresentation Component
 */
export const SelectLanguageBoard: React.FC<SelectLanguageBoardProps> = ({
  isDisplay,
  glossary,
  onClickClose,
  items,
  selectedLanguage
}) => {
  // Languagesに渡すpropsを生成
  const _props = {
    items,
    selectedLanguage,
    selectedRegion: '',
    selectedCountry: '',
    selectedPurchase: ''
  };
  return isDisplay ? (
    <div
      className="selectLanguageBoard hideScrollbar"
      data-test="selectLanguageBoard"
    >
      <Button
        type="toolButton"
        subType="close"
        data-test={`selectLanguageBoard-close-toolButton`}
        onClick={onClickClose}
      />
      <Message type="message" data-test="selectLanguageBoard-message">
        {glossary.glx(BoardGL.SelectLanguageMessage)}
      </Message>
      <Separator type="separator" data-test="selectLanguageBoard-separator" />
      <Items
        type="language"
        {..._props}
        data-test="selectLanguageBoard-languages"
      />
    </div>
  ) : null;
};
